import * as action_types from "./constants";
var _ = require("lodash");

const initialState: any = {
  shiftData: null,
  zonesData: [],
  techProperty: [],
  categoriesList: [],
  techniciansList: [],
  selectedCompany: null,
  providers: [],
  centers: [],
  selectedProvider: null,
  holidaysData: [],
};

export default (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_OPERATING_HOURS:
      return { ...state, operatingHours: data };
    case action_types.GET_SHIFTS_LIST:
      return { ...state, shiftData: data };
    case action_types.GET_SHIFT:
      return { ...state, techProperty: data };
    case action_types.GET_MAINTANANCE_CATEGORIES:
      return {
        ...state,
        categoriesList: {
          residential: _.map(data?.residential, (item) => ({
            value: item.categoryId,
            label: item.name,
          })),
          commercial: _.map(data?.commercial, (item) => ({
            value: item.categoryId,
            label: item.name,
          })),
          internal: _.map(data?.internal, (item) => ({
            value: item.categoryId,
            label: item.name,
          })),
        },
      };
    case action_types.GET_SP_TECHNICIANS:
      return {
        ...state,
        techniciansList: _.map(data, (item) => ({
          value: item.userId,
          label: item.name,
        })),
      };
    case action_types.FETCH_PROVIDERS_SUCCESS:
      return { ...state, providers: data };

    case action_types.FETCH_CENTERS_SUCCESS:
      return { ...state, centers: data };

    case action_types.SELECT_COMPANY:

      return { ...state, selectedCompany: data };

    case action_types.SET_PROVIDERS:
      return { ...state, selectedProvider: data };

    case action_types.GET_HOLIDAYS:
      return { ...state, holidaysData: data };

    case action_types.SET_CENTER:
      return { ...state, selectedCenter: data };
    default:
      return state;
  }
};
